// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function routeMatcher(url) {
  var match = url.path;
  if (!match) {
    return /* UnknownRoute */0;
  }
  var exit = 0;
  if (match.hd === "buy") {
    var match$1 = match.tl;
    if (!match$1) {
      return /* UnknownRoute */0;
    }
    if (match$1.hd === "auction") {
      var match$2 = match$1.tl;
      if (!match$2) {
        return /* UnknownRoute */0;
      }
      var match$3 = match$2.tl;
      if (!match$3) {
        return /* UnknownRoute */0;
      }
      var match$4 = match$3.tl;
      if (!match$4) {
        return /* UnknownRoute */0;
      }
      if (match$4.hd === "auctionroom") {
        if (!match$4.tl) {
          return /* LiveRoom */{
                  _0: match$2.hd,
                  _1: match$3.hd
                };
        }
        exit = 1;
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var match$5 = match.tl;
    if (!match$5) {
      return /* UnknownRoute */0;
    }
    var exit$1 = 0;
    if (match$5.hd === "buy") {
      var match$6 = match$5.tl;
      if (!match$6) {
        return /* UnknownRoute */0;
      }
      if (match$6.hd === "auction") {
        var match$7 = match$6.tl;
        if (!match$7) {
          return /* UnknownRoute */0;
        }
        var match$8 = match$7.tl;
        if (!match$8) {
          return /* UnknownRoute */0;
        }
        var match$9 = match$8.tl;
        if (match$9 && match$9.hd === "auctionroom" && !match$9.tl) {
          return /* LiveRoom */{
                  _0: match$7.hd,
                  _1: match$8.hd
                };
        } else {
          return /* UnknownRoute */0;
        }
      }
      exit$1 = 2;
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      var match$10 = match$5.tl;
      if (!match$10) {
        return /* UnknownRoute */0;
      }
      if (match$10.hd !== "buy") {
        return /* UnknownRoute */0;
      }
      var match$11 = match$10.tl;
      if (!match$11) {
        return /* UnknownRoute */0;
      }
      if (match$11.hd !== "auction") {
        return /* UnknownRoute */0;
      }
      var match$12 = match$11.tl;
      if (!match$12) {
        return /* UnknownRoute */0;
      }
      var match$13 = match$12.tl;
      if (!match$13) {
        return /* UnknownRoute */0;
      }
      var match$14 = match$13.tl;
      if (match$14 && match$14.hd === "auctionroom" && !match$14.tl) {
        return /* LiveRoom */{
                _0: match$12.hd,
                _1: match$13.hd
              };
      } else {
        return /* UnknownRoute */0;
      }
    }
    
  }
  
}

function getCurrentRoute(param) {
  return routeMatcher(RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined));
}

export {
  routeMatcher ,
  getCurrentRoute ,
}
/* RescriptReactRouter Not a pure module */
